module.exports = __webpack_public_path__ + "static/img/0000镇赉叫号2.928dc4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/0000镇赉叫号2.jpg
// module id = Eqc0
// module chunks = 0